import { Button } from '@nimbus-ds/components';
import { Stack } from 'commons/components';
import { useTranslationCustomers } from 'domains/Customers/hooks';

interface ModalButtonsProps {
  handleReset: () => void;
  handleApply: () => void;
}

export default function ModalButtons({
  handleReset,
  handleApply,
}: Readonly<ModalButtonsProps>) {
  const t = useTranslationCustomers();
  return (
    <Stack spacing="base" justify="flex-end">
      <Stack.Item>
        <Button onClick={handleReset}>
          {t('customerListPage.filterModal.cleanFilter')}
        </Button>
      </Stack.Item>
      <Stack.Item>
        <Button onClick={handleApply} appearance="primary">
          {t('customerListPage.filterModal.filter')}
        </Button>
      </Stack.Item>
    </Stack>
  );
}
